// -----------------------------------
// Google reCAPTCHA layout
// -----------------------------------
/* 自我流設定reCAPTCHA排版(配合HTML、CSS、JS、JSON)
	* 使用 Google reCAPTCHA v2 版本 API
	* 語言設定為 2019/01/15 Google reCAPTCHA 版本
	* 固定HTML
	<div class="recaptcha-wrapper">
		<div class="recaptcha-layout">
			<div class="g-recaptcha-box" data-sitekey="{{reCAPTCHA_site_key}}"></div>
			<div class="rc-footer" aria-hidden="true">
				<div class="rc-logo">
					<div class="rc-logo-img"></div>
					<div class="rc-logo-text">reCAPTCHA</div>
				</div>
				<div class="rc-link">
					<a href="https://policies.google.com/privacy" tabindex="-1" class="link-privacy" target="_blank">Privacy</a>
					<span aria-hidden="true" role="presentation"> - </span>
					<a href="https://policies.google.com/terms" tabindex="-1" class="link-terms" target="_blank"></a>
				</div>
			</div>
		</div>
	</div>
	--------------
	* 設定
		- 一般形式為：Logo上；隱私權、條款下
		- 改變為左右排版：手動於 .rc-footer 增加class .left-right"
			※左右排版可能會因為「隱私權、條款」文字過長而覆蓋到「我不是機器人」文字
		- 建議寬度至少要320px以上
		- 針對各語言設定可使用Selector: .recaptcha-layout[lang="{{reCAPTCHA_語言code}}"]
	--------------
	* 提醒
		- 左右排版可能會因為「隱私權、條款」文字過長而覆蓋到「我不是機器人」文字
		- 逾時後的事件設定，如果不使用重設，顯示上的Bug是無可避免，目前盡可能調到最佳狀態
	--------------
	* 各語言問題
		- Indonesian:
			reCAPTCHA Language Code 為 id，但reCAPTCHA抓取的網址為 "in" ，因此設定 data.value2檢查
		- Malayalam, Tamil: 
			逾時錯字過長會遮到「我不是機器人」文字，只能重設
	--------------
	* 相關連結
		- 語言設定： https://developers.google.com/recaptcha/docs/language
		- 參考JS： https://stackoverflow.com/a/48363563
					https://jsfiddle.net/7umzsmus/4/
*/
(function (window, document) {

	var rcLayout = document.querySelector('.recaptcha-layout'),
		captcha_container,
		captcha_iframe,
		expErrorMsg, // 存放逾時錯誤文字
		iframeMouseOver = false, // 監聽是否點擊 iframe 參數
		isExpiredClass = "is-expired", // 逾時Class
		expiredReset = false, // 逾時時是否要直接重設
		windowIsDetecting = false;

	function buildReCAPTCHA() {

		// 如果Google reCAPTCHA 不存在於頁面
		if (window.grecaptcha === undefined) return false;

		// 如果 .recaptcha-layout 不存在於頁面上 => 不執行
		if (rcLayout === null) return false;

		// reCAPTCHA Ready
		grecaptcha.ready(function () {

			// Render reCAPTCHA div | 算出reCAPTCHA區塊
			captcha_container = rcLayout.querySelector('.g-recaptcha-box');

			// 設定Success Callback
			// 如果逾時使用重設則不需要callback
			var rcCallback = (expiredReset) ? null : expRemoveHandler;

			// Render reCAPTCHA
			var reCaptchaSiteKey = captcha_container.getAttribute('data-sitekey');
			grecaptcha.render(captcha_container, {
				'sitekey': reCaptchaSiteKey,
				'callback': rcCallback,
				'expired-callback': expCallback
			});

			// Get Iframe
			captcha_iframe = captcha_container.querySelector('iframe');

			// Build Language
			var lang = getCurrentLanguageCode();
			buildReCAPTCHALanguage(lang);
		});
	}

	// Start
	window.addEventListener('load', buildReCAPTCHA);

	// ----------------------------------------------
	// 取得語言設定 Function
	function getCurrentLanguageCode() {

		// 取得語言設定
		var currentLanguage = captcha_iframe.getAttribute("src").match(/hl=(.*?)&/).pop();

		return currentLanguage
	}

	function buildReCAPTCHALanguage(lang) {

		// Load Google reCAPTCHA Language Json data | 讀取語言Json設定
		loadJSON("/json/g-recaptcha-lang.json", function (response) {

			// Parse JSON string into object
			var actual_JSON = JSON.parse(response);

			// Find Language setting | 從Json尋找語言設定
			var data;
			for (var i = 0; i < actual_JSON.length; i++) {
				if (actual_JSON[i].value == lang || actual_JSON[i].value2 == lang) {
					data = actual_JSON[i];
					break;
				}
			}

			// If no data found, use English to instead of it. | 如果找不到資料，用英文取代
			if (data === undefined) {
				data = {
					"lang": "English (US)",
					"value": "en",
					"robot": "I'm not a robot",
					"privacy": "Privacy",
					"terms": "Terms",
					"error_expired": "Verification expired. Check the checkbox again."
				}
				lang = data.value;
			}

			// If text direction is right to left (rtl) | 如果是從右至左排版，更改設定
			if (data.dir === "rtl") {
				rcLayout.classList.add('rtl');
			} else {
				rcLayout.classList.remove('rtl');
			}

			// Change Language Setting | 更換語言設定
			var rclink = rcLayout.querySelector('.rc-link');

			// Privacy | 隱私權
			var rclink_privacy = rclink.children[0];
			rclink_privacy.innerHTML = data.privacy;
			rclink_privacy.href = 'https://www.google.com/intl/' + lang + '/policies/privacy/';

			// Terms | 條款
			var rclink_terms = rclink.children[2];
			rclink_terms.innerHTML = data.terms;
			rclink_terms.href = 'https://www.google.com/intl/' + lang + '/policies/terms/';

			// Error Message | 錯誤逾期問題
			expErrorMsg = document.createElement('div');
			expErrorMsg.className = "rc-expired-msg";
			expErrorMsg.innerHTML = data.error_expired;
			expErrorMsg.setAttribute('aira-hidden', true);

			// Add class to show completed style | 增加完成Class
			rcLayout.classList.add('rc-loaded');

			// Set Language (for Class) | 紀錄語言，可以針對各語言設定CSS
			rcLayout.setAttribute('data-lang', data.value);

			// ---
			// Fixed Language Bug | 調整各語言Bug
			// Malayalam
			if (lang === 'ml' || lang === 'ta') expiredReset = true;
		});
	}


	// ----------------------------------------------
	// 逾時
	function expCallback() {
		// console.log('expCallback')
		if (expiredReset) {
			// 重設
			setTimeout(() => {
				grecaptcha.reset();
			}, 20);
		} else {
			rcLayout.classList.add(isExpiredClass);
			buildExpListener();

			// Append Error Msg
			rcLayout.parentElement.appendChild(expErrorMsg);
		}
	};

	function expRemoveHandler() {
		// console.log('expRemoveHandler')
		if (!expiredReset) {
			rcLayout.classList.remove(isExpiredClass);
			if (windowIsDetecting) {
				removeExpListener();
			}

			// Remove Error Msg
			expErrorMsg.remove();
		}
	}

	// For Expired | 針對逾時的對策
	// 因為API沒有開放reset callback，所以只能另外的方法監聽Iframe是否有Click
	// Because there is no API to call function after Reset, so use other way to detect iframe click.
	// Reference | 參考：https://stackoverflow.com/a/39559600
	function buildExpListener() {
		// console.log('buildExpListener')
		windowIsDetecting = true;
		window.addEventListener('blur', windowBlur);
		captcha_container.addEventListener('mouseover', iframeMouseOverToTrue);
		captcha_container.addEventListener('mouseout', iframeMouseOverToFalse);
	}

	function removeExpListener() {
		// console.log('removeExpListener')
		windowIsDetecting = false;
		window.removeEventListener('blur', windowBlur);
		captcha_container.removeEventListener('mouseover', iframeMouseOverToTrue);
		captcha_container.removeEventListener('mouseout', iframeMouseOverToFalse);
	}

	function windowBlur() {
		if (iframeMouseOver) {
			// console.log('Wow! Iframe Click!');
			expRemoveHandler();
		}
	}

	function iframeMouseOverToTrue() {
		iframeMouseOver = true;
	}

	function iframeMouseOverToFalse() {
		iframeMouseOver = false;
	}


	// ----------------------------------------------
	// Load Json File
	// https://codepen.io/KryptoniteDove/post/load-json-file-locally-using-pure-javascript
	function loadJSON(filePath, callback) {

		var xobj = new XMLHttpRequest();
		xobj.overrideMimeType("application/json");
		xobj.open('GET', filePath, true);
		xobj.onreadystatechange = function () {
			if (xobj.readyState == 4 && xobj.status == "200") {
				// Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
				callback(xobj.responseText);
			}
		};
		xobj.send(null);
	}

	// ---
	// JavaScript remove() doesn't work in IE
	// https://stackoverflow.com/a/37477096
	// Create Element.remove() function if not exist
	if (!('remove' in Element.prototype)) {
		Element.prototype.remove = function () {
			if (this.parentNode) {
				this.parentNode.removeChild(this);
			}
		};
	}

})(window, document);







// --------------------------------------------------
// Connect Container
(function ($, window, document) {


	// ----------------------------------- Start : Setting

	// 取得裝置判斷
	// isMobile 判斷
	var isMobile = false;
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true
	}
	// ----------------------------------- End : Setting


	// 監測表單是否有值
	var hasValClass = 'has-value';
	var detectedFormItem = function (el) {
		var isSelect = el.tagName.toUpperCase() == 'SELECT';
		if (el.value.replace(/^\s+|\s+$/g, "") === '' || isSelect && el.value == 'none') {
			// 等於空值
			el.classList.remove(hasValClass)
		} else {
			// 不等於空值
			el.classList.add(hasValClass)
		}
	}

	// 建立監測
	var buildFormDetected = function (targetNodeList) {
		if (targetNodeList.length > 0) {
			[].forEach.call(targetNodeList, function (el) {
				var isSelect = el.tagName.toUpperCase() == 'SELECT';
				detectedFormItem(el);
				if (isSelect) {
					// Select 情況
					el.addEventListener("change", function () {
						detectedFormItem(this);
					});
				} else {
					// Input & Textarea 情況
					el.addEventListener("focusout", function () {
						detectedFormItem(this);
					});
				}
			});
		}
	}

	var formBox = document.querySelector('.form-box');

	if (formBox != null) {
		var formInput = formBox.querySelectorAll('input');
		var formTextarea = formBox.querySelectorAll('textarea');
		var formSelect = formBox.querySelectorAll('select');

		buildFormDetected(formInput);
		buildFormDetected(formTextarea);
		buildFormDetected(formSelect);
	}



	// ------------------------------------------------------------
	// Change Textarea Height | 輸入文字計算高
	// Reference: https://stackoverflow.com/a/25621277
	var tx = document.getElementsByTagName('textarea');
	var calcTextareaHeight = function () {

		// 如果頁面上沒有
		if (tx.length === 0) return false;

		for (var i = 0; i < tx.length; i++) {
			tx[i].setAttribute('style', 'height:' + (tx[i].scrollHeight) + 'px;overflow-y:hidden;');
			tx[i].addEventListener("input", OnInput, false);

			// 貼上 (For Mobile)
			if (isMobile) {
				tx[i].on('paste', function () {
					setTimeout(function () {
						// Change Scroll 如果超過 Sreen
						var textareaOffsetBottom = tx.offset().top + tx.innerHeight();
						alert(ws + wh + "\n" + textareaOffsetBottom)
						if (ws + wh < textareaOffsetBottom) {
							$(window).scrollTop(textareaOffsetBottom - wh + 40);
						}
					}, 10);
				});
			}
		}

		function OnInput() {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 'px';
		}
	}
	calcTextareaHeight();







	// ------------------------------------------------------------
	// Detecting autofilled fields in Javascript
	// Add Style In html
	// 因為壓縮CSS後動畫名稱會變動，所以要用JS加入<style>
	var css = "@keyframes onAutoFillStart {  from {/**/}  to {/**/}}@-webkit-keyframes onAutoFillStart {  from {/**/}  to {/**/}}\
				@keyframes onAutoFillCancel {  from {/**/}  to {/**/}}@-webkit-keyframes onAutoFillCancel {  from {/**/}  to {/**/}}",
		head = document.head || document.getElementsByTagName('head')[0],
		style = document.createElement('style');

	style.type = 'text/css';
	if (style.styleSheet) {
		// This is required for IE8 and below.
		style.styleSheet.cssText = css;
	} else {
		style.appendChild(document.createTextNode(css));
	}

	head.appendChild(style);
	// -----------------
	// Reference: https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7
	const AUTOFILLED = 'is-autofilled';
	const onAutoFillStart = (el) => el.classList.add(AUTOFILLED);
	const onAutoFillCancel = (el) => el.classList.remove(AUTOFILLED);
	const onAnimationStart = ({
		target,
		animationName
	}) => {
		switch (animationName) {
			case 'onAutoFillStart':
				return onAutoFillStart(target)
			case 'onAutoFillCancel':
				return onAutoFillCancel(target)
		}
	}

	var buildAutoFillRegisterListener = (selector) => {
		var target = document.querySelectorAll(selector);
		if (target.length === 0) return false;
		[].forEach.call(target, (el) => {
			el.addEventListener('animationstart', onAnimationStart, false);
		})
	}

	buildAutoFillRegisterListener('input');
	buildAutoFillRegisterListener('select');
	buildAutoFillRegisterListener('textarea');

	// ------------------------------------------------------------



})(jQuery, window, document);